export default __webpack_public_path__ + "assets/qr-code-advantages-reduce-print-cost.ed2a5cb3.svg";